import moment from 'moment';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import React from 'react';

import ContentMetadataCommentSourceCssClasses from './helpers';

const {enums} = window.sn;
const {ContentMetadataCommentSource} = enums;

const ActivityPrefixes = {
    [ContentMetadataCommentSource.OPS_REQUEST_FIX]: 'Fix requested by',
    [ContentMetadataCommentSource.OPS_REJECT]: 'Rejected by',
    [ContentMetadataCommentSource.GENERAL_NOTE]: ''
};
const ActivityFeedItem = ({user_email, activity_type, activity_message, activity_timestamp}) => {
    const messageLines = R.is(Array, activity_message)
        ? activity_message
        : activity_message.split('\n');
    const activityClass = ContentMetadataCommentSourceCssClasses[activity_type];
    return (
        <div className="activity">
            <div className="activity-item-header">
                {`${R.propOr('', activity_type, ActivityPrefixes)} ${user_email}`}
            </div>
            <div className={`activity-item-body ${activityClass}`}>
                {// Messages might have return carriages, and we cannot let this be a
                // textarea since the content should not scroll in overflow scenarios
                // so we'll just replace return carriages with breaks
                messageLines.map((item, key) => (
                    <span key={key}>
                        {item}
                        {// do not break after the last line
                        key !== messageLines.length - 1 ? <br /> : null}
                    </span>
                ))}
            </div>
            <div className="activity-item-footer pull-right">
                {moment
                    .utc(activity_timestamp)
                    .local()
                    .format('MM/DD/YYYY h:mm a')}
            </div>
        </div>
    );
};
ActivityFeedItem.propTypes = {
    user_email: PropTypes.string.isRequired,
    activity_type: PropTypes.oneOf(R.values(ContentMetadataCommentSource)),
    activity_message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    activity_timestamp: PropTypes.string.isRequired
};

export default ActivityFeedItem;



// WEBPACK FOOTER //
// ./approval_queues/components/activity_feed/activity_feed_item.js